import { render, staticRenderFns } from "./NFTImageCard.vue?vue&type=template&id=e97130f0&scoped=true&"
import script from "./NFTImageCard.vue?vue&type=script&lang=ts&"
export * from "./NFTImageCard.vue?vue&type=script&lang=ts&"
import style0 from "./NFTImageCard.vue?vue&type=style&index=0&id=e97130f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97130f0",
  null
  
)

export default component.exports